<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12 lg4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-dumbbell</v-icon>
              Modelo de Treinos
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 lg8>
          <v-layout row wrap justify-end>
            <v-text-field v-model="search" class="search-input" label="Buscar"
              append-icon="fal fa-search"></v-text-field>
            <v-btn round depressed large color="success" dark
              @click="router.push({ name: 'AdminNewTraining' })">
              NOVO MODELO
              <v-icon small right>fal fa-plus-circle</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <empty-alert :icon="'dumbbell'" :color="'orange accent-4'" v-if="!trainings.length">
      <div slot="content">
        <p><strong>Nenhum treino encontrado.</strong></p>
      </div>
    </empty-alert>

    <v-flex xs12 class="section-box" v-if="trainings.length">
      <v-data-table
        width="100%"
        :headers="headers"
        :items="trainings"
        :search="search"
        sort-icon="fal fa-arrow-down"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>
            <router-link :to="{ name: 'AdminEditTraining', params: { id: props.item._id }}">
              {{ props.item.name }}
            </router-link>
          </td>
          <td>{{ props.item.level }}</td>
          <td>{{ props.item.sessions }}</td>
          <td>
            {{ props.item.description }}
          </td>
          <td class="align-center text-xs-right">
            <router-link :to="{ name: 'AdminEditTraining', params: { id: props.item._id }}">
              <v-icon flat small color="blue-grey lighten-2" class="mr-2">
                fal fa-edit
              </v-icon>
            </router-link>
            <v-icon flat small color="red lighten-2" @click="deleteItem(props.item)">
              fal fa-trash-alt
            </v-icon>
          </td>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="black" outline>
            Nenhum treino encontrado.
          </v-alert>
        </template>
        <template slot="no-data">
          <div class="my-3 text-xs-center">
            Nenhum treino encontrado.
          </div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import router from '@/router'

export default {
  data: () => ({
    search: '',
    router: router,
    headers: [
      { text: 'Nome', value: 'name', width: '300' },
      { text: 'Nível', value: 'muscle', width: '200' },
      { text: 'Sessões', value: 'type', width: '200' },
      { text: 'Descrição', value: 'description', width: '500' },
      { text: '', value: 'name', sortable: false, width: '100' }
    ],
    trainings: []
  }),

  methods: {
    loadTrainings () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      axios.get(`${API.userTrainings}?save_into_model=true`).then(response => {
        this.trainings = response.data.trainings
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar os treinos', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    },

    editItem (item) {
      EventBus.$emit('showNewEditTraining', true)
    },

    deleteItem (item, confirmUnRequired) {
      // eslint-disable-next-line
      const path = `${API.userTrainings}/${item._id}`
      const index = this.trainings.indexOf(item)

      if (!confirmUnRequired) {
        confirm(`Tem certeza que deseja apagar o treino "${item.name}" ?`) && this.deleteItem(item, true)
        return
      }

      axios.delete(path).then(response => {
        this.trainings.splice(index, 1)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro apagar o item', color: 'error' })
        EventBus.$emit('appLoading', false)
        EventBus.$emit('loadTrainings')
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadTrainings')
  },

  created () {
    this.loadTrainings()
    EventBus.$on('loadTrainings', this.loadTrainings)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminTrainings.vue